// @flow

import React from 'react';
import Rows from '@leasen_nl/listo/src/components/rows';
import type { ACFPage } from '@leasen_nl/listo/src/types';
import { ActiveItem } from './atoms';

type OwnProps = {
  acf: ACFPage,
};

type Props = OwnProps;

const FAQItemPage = ({
  acf: {
    rows,
  },
}: Props) => (
  <>
    <Rows rows={rows} />
    <ActiveItem />
  </>
);

export default FAQItemPage;
